<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('leaderboard')" icon="briefcase">
    </app-page-top-section>

<!--    <app-filter-with-search-->
<!--        :options="options"-->
<!--        @filteredValue="setFilterValues"-->
<!--        @searchValue="setSearchValue"-->
<!--    />-->
    <div class="card card-with-shadow border-0">
      <div class="card-header d-flex align-items-center justify-content-between p-primary primary-card-color">
        <app-month-calendar :periods-url="apiUrl.SELECTABLE_LEADERBOARD_PERIODS"/>

        <app-period-calendar :filters="monthFilters"/>
      </div>

      <div class="card-body">
        <app-table
            id="leaderboard-table"
            :options="tableOptions"
            @getRows="getSelectedRows"
            @action="triggerActions"
        />
      </div>
    </div>

  </div>
</template>

<script>
import LeaderboardMixin from "../../../../Mixins/LeaderboardMixin";
import {LEADERBOARD} from "../../../../../Config/ApiUrl";
// import EmployeeContextMenu from "../../Components/EmployeeContextMenu";
// import JobHistoryEditModal from "../../Components/JobHistory/components/JobHistoryEditModal";
// import {axiosGet} from "../../../../../../common/Helper/AxiosHelper";
// import EmployeeCreateEditModel from "../../EmployeeCreateEditModal"

export default {
  components: {},
  mixins: [LeaderboardMixin],
  data() {
    return {
      monthFilters: [
        {
          id: 'thisMonth',
          value: this.$t('this_month')
        },
        {
          id: 'lastMonth',
          value: this.$t('last_month')
        },
      ]
    };
  },
  mounted() {
  },
  methods: {
    reload() {
      this.tableOptions.url = `${LEADERBOARD}?${this.queryString}`
      this.$hub.$emit('reload-leaderboard-table')
    }
  },
  computed: {
    queryString() {
      return this.$store.getters.getFilterUrls;
    },
  },
  watch: {
    queryString: {
      handler: function (queryString) {
        if (!queryString) {
          return;
        }
        this.reload()
      },
      immediate: true
    }
  },
}
</script>
